module.exports = __webpack_public_path__ + "media/images/shopify_faq_8-7fd19bd4b61e65ed19077cdec59afb8c.png";